<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer005">
<p class="pl-title"><a id="_idTextAnchor000"></a>Convenient Christmas Brides</p>
<p class="pl-author">Carla Kelly<br/>Louise Allen<br/>Laurie Benson</p>
<p class="pl-logo"><img alt="logo" height="50" src="image/Har_Historical_2012_Cab_Blk.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title_Page.vue?11ff3f65